export default {
  title: {
    id: 'review_ai_summary_title',
    defaultMessage: 'What customers are saying',
  },
  caption: {
    id: 'review_ai_summary_caption',
    defaultMessage: 'AI generated',
  },
  tooltip: {
    id: 'review_ai_summary_tooltip',
    defaultMessage:
      'Summary created by AI from recent customer feedback over 6 months, last updated on {updateDate}',
  },
} as const
